import { post } from "../../utils/Backend";
import { useH5Mock } from "../../global/GlobalMock";
import {
  mockGetLatestViewpoints,
  mockGetOldViewpoints,
  mockListViewpointCategories,
  mockToggleViewpointCollect,
  mockToggleViewpointLike,
} from "./ViewpointFeedMock";
import type {
  ViewpointFeedCategoryListResult,
  ViewpointFeedEngagementParam,
  ViewpointFeedEngagementState,
  ViewpointFeedSliceQuery,
  ViewpointFeedSliceResult,
} from "./ViewpointFeedTypes";

const mockViewpointFeed = useH5Mock && false;

export const ViewpointFeedApi = {
  async getOldViewpoints(
    query: ViewpointFeedSliceQuery
  ): Promise<ViewpointFeedSliceResult | string> {
    if (mockViewpointFeed) {
      return mockGetOldViewpoints(query);
    }
    return post<ViewpointFeedSliceQuery, ViewpointFeedSliceResult>(
      "/lark/app/viewpointFeed/getOldViewpoints",
      query,
      { silent: true }
    );
  },

  async getLatestViewpoints(
    query: ViewpointFeedSliceQuery
  ): Promise<ViewpointFeedSliceResult | string> {
    if (mockViewpointFeed) {
      return mockGetLatestViewpoints(query);
    }
    return post<ViewpointFeedSliceQuery, ViewpointFeedSliceResult>(
      "/lark/app/viewpointFeed/getLatestViewpoints",
      query,
      { silent: true }
    );
  },

  async toggleLike(
    param: ViewpointFeedEngagementParam
  ): Promise<ViewpointFeedEngagementState | string> {
    if (mockViewpointFeed) {
      return mockToggleViewpointLike(param);
    }
    return post<ViewpointFeedEngagementParam, ViewpointFeedEngagementState>(
      "/lark/app/viewpointFeed/toggleViewpointLike",
      param,
      { silent: true }
    );
  },

  async toggleCollect(
    param: ViewpointFeedEngagementParam
  ): Promise<ViewpointFeedEngagementState | string> {
    if (mockViewpointFeed) {
      return mockToggleViewpointCollect(param);
    }
    return post<ViewpointFeedEngagementParam, ViewpointFeedEngagementState>(
      "/lark/app/viewpointFeed/toggleViewpointCollect",
      param,
      { silent: true }
    );
  },

  async listViewpointCategories(query: {
    spaceId: string;
    spaceProductId: string;
  }): Promise<ViewpointFeedCategoryListResult | string> {
    if (mockViewpointFeed) {
      return mockListViewpointCategories(query);
    }
    return post<
      { spaceId: string; spaceProductId: string },
      ViewpointFeedCategoryListResult
    >("/lark/app/viewpointFeed/listViewpointCategories", query, { silent: true });
  },
};
